export default "__VITE_ASSET__W5V3GGoR__"